/**
 * Loading placeholders shown while initial data fetches.
 *
 * Use `<CardSkeleton count={n} />` on list pages (Computers, Sharing,
 * Printers, Backups) instead of the bare "Loading…" text. Card-shaped
 * placeholders make slow networks feel intentional rather than broken,
 * and the dimensions match the real cards so the page doesn't jump
 * when the data arrives.
 */

export function CardSkeleton({ count = 3 }: { count?: number }) {
  return (
    <ul className="space-y-3" aria-label="Loading" aria-busy>
      {Array.from({ length: count }).map((_, i) => (
        <li
          key={i}
          className="rounded-2xl border border-slate-200 bg-white p-5"
        >
          <div className="flex items-start gap-4">
            <div className="mt-1 h-2.5 w-2.5 shrink-0 animate-pulse rounded-full bg-slate-200" />
            <div className="min-w-0 flex-1 space-y-2">
              <div className="h-4 w-1/3 animate-pulse rounded bg-slate-200" />
              <div className="h-3 w-2/3 animate-pulse rounded bg-slate-100" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

/** Inline single-line skeleton, for forms or smaller surfaces. */
export function LineSkeleton({ width = "w-32" }: { width?: string }) {
  return <span className={`inline-block h-4 ${width} animate-pulse rounded bg-slate-200`} />;
}
